<template>
  <div v-if="publications" id="publications">
    <sub-menu id="section-submenu" nohide="true"></sub-menu>

    <h3 class="my3 center caps">Featured Publications</h3>
    <div class="mx2 sm-mx3">
      <div
        v-if="publications"
        v-for="publication in featuredPublications"
        class="row clearfix border-top py1 block publication-row border-black pt2 pb2"
        :key="publication.id"
        :ref="`pub-${publication.id}`">
          <span class="scroll-anchor" :id="`${publication.slug}`"></span>
          <div class="col col-3 sm-col-2 pr2">
            <img class="thumbnail mx-auto" :src="publicationCover(publication)" />
            <div class="sm-hide sm-hide md-hide lg-hide col-12 flex">
              <a target="_blank" v-if="publication.acf.read_link" class="button py1 mt1 block flex-auto" :href=publication.acf.read_link>Read</a>
              <a target="_blank" v-if="publication.acf.publisher_link" class="button py1 mt1 block flex-auto" :href=publication.acf.publisher_link>Publisher</a>
              <a target="_blank" v-if="publication.acf.purchase_link" class="button py1 mt1 block flex-auto" :href=publication.acf.purchase_link>Buy</a>
            </div>
          </div>
          <div class="col col-9 sm-col-6 tabular px2">
            <span class="citation red" v-if="publication.acf.citation" v-html="publication.acf.citation" />
            <span v-else v-html="publication.title.rendered" />
            <span class="xs-hide mt1" v-if="publication.acf.language !== '' && publication.acf.language !== 'EN'">({{ publication.acf.language }})</span>
            <div class="tabular sm-hide md-hide lg-hide py1">
              {{ publicationYear(publication) }}<span class="mt1" v-if="publication.acf.language !== '' && publication.acf.language !== 'EN'">&nbsp;({{ publication.acf.language }})</span>
            </div>
            <div class="fade" v-html="publication.acf.description" />
              <p class="fs-s red pointer" @click="togglePub(`pub-${publication.id}`)">
                <span class="toggle-show">Read More...</span>
                <span class="toggle-hide">Read Less...</span>
              </p>
            </div>
          <div class="xs-hide col col-1 tabular px2">{{ publicationYear(publication) }}</div>
          <div class="xs-hide col col-3 pl2 flex">
            <a target="_blank" v-if="publication.acf.read_link" class="button p2 block flex-auto ml2" :href=publication.acf.read_link>Read</a>
            <a target="_blank" v-if="publication.acf.publisher_link" class="button p2 block flex-auto ml2" :href=publication.acf.publisher_link>Publisher</a>
            <a target="_blank" v-if="publication.acf.purchase_link" class="button p2 block flex-auto ml2" :href=publication.acf.purchase_link>Buy</a>
          </div>
        </div>
      </div>

    <section v-if="otherPublications && otherPublications.length">
      <h3 class="mb3 center caps">Other Publications</h3>
      <div class="mx2 sm-mx3">
        <div
          v-if="publications"
          v-for="publication in otherPublications"
          class="row clearfix border-top py1 block other-publication-row border-black"
          :key="publication.id">
            <span class="scroll-anchor" :id="`${publication.slug}`"></span>
            <div class="col col-8 tabular pr2">
              <span class="citation" v-if="publication.acf.citation" v-html="publication.acf.citation" />
              <span v-else v-html="publication.title.rendered" />
              <p class="sm-hide md-hide lg-hide">{{ publicationYear(publication) }}</p>
            </div>
            <div class="col col-1 tabular pr2 xs-hide">{{ publicationYear(publication) }}</div>
            <div class="col col-4 sm-col-3 sm-pl2 flex">
              <a target="_blank" v-if="publication.acf.read_link" class="button p1 sm-p2 block flex-auto ml2" :href=publication.acf.read_link>Read</a>
              <a target="_blank" v-if="publication.acf.publisher_link" class="button p1 sm-p2 block flex-auto ml2" :href=publication.acf.publisher_link>Publisher</a>
              <a target="_blank" v-if="publication.acf.purchase_link" class="button p1 sm-p2 block flex-auto ml2" :href=publication.acf.purchase_link>Buy</a>
            </div>
          </div>
        </div>
      </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import {formatDate} from '../utils'
import SubMenu from '@/components/SubMenu'
import PublicationPreview from '@/components/PublicationPreview'

export default {

  name: 'Publications',

  data () {
    return {

    }
  },

  metaInfo () {
    let title = 'Publications'
    return {
      title: title,
      meta: [
        { name: 'og:title', content: `${process.env.VUE_APP_TITLE} → ${title}` },
        { name: 'twitter:title', content: `${process.env.VUE_APP_TITLE} → ${title}` },
        { name: 'og:image', content: '/fa-share-lg.png' },
        { name: 'twitter:image', content: '/fa-share-lg.png' },
        { name: 'og:url', content: `${window.location.origin}/${this.$route.fullPath}` },
        { name: 'og:type', content: 'website' },
        { name: 'og:description', content: this.siteDescription() },
        { name: 'twitter:description', content: this.siteDescription() }
      ]
    }
  },

  computed: {
    ...mapState([
      'publications'
    ]),
    ...mapGetters([
      'featuredPublications',
      'otherPublications'
    ])
  },

  mounted () {
    this.scrollToAnchor()
  },

  methods: {
    formatDate,
    publicationCover (item) {
      if (item.acf.cover_image) {
        return item.acf.cover_image.sizes['large']
      } else {
        return false
      }
    },
    publicationYear (item) {
      if (item.acf.year) {
        return item.acf.year
      } else {
        return '-'
      }
    },
    togglePub (item) {
      let el = this.$refs[item][0]
      if (el.classList.contains('open')) {
        el.classList.remove('open')
      } else {
        el.classList.add('open')
      }
    },
    scrollToAnchor () {
      const anchor = this.$route.hash
      this.$nextTick(() => {
        if (anchor && document.querySelector(anchor)) {
          location.href = anchor
        }
      })
    }
  },

  watch: {
    '$route' () {
      this.scrollToAnchor()
    }
  },

  components: {
    SubMenu,
    PublicationPreview
  }
}
</script>

<style lang="css" scoped>
  #publications {
    margin-bottom: 3em;
  }
  img {
    max-width: 100%;
    height: auto;
  }
  #publication-items {
    margin-top: 3em;
  }
  .publication-row, .other-publication-row {
    font-size: var(--font-size-reader);
    line-height: var(--line-height-reader);
    .p {
      margin-top: var(--line-height-reader);
    }
    .citation >>> p {
      margin: 0;
      padding: 0;
    }
    a.button {
      overflow-x: hidden;
      text-overflow: ellipsis;
    }
  }

  .other-publication-row:hover >>> em {
    color: var(--red);
  }

  .button-placeholder {
    border: 1px solid transparent;
    opacity: 0;
  }
  .fade {
    position: relative;
    max-height: calc(var(--line-height-reader) * 5.94);
    overflow: hidden;

    >>> p {
      margin-top: var(--line-height-reader);
      margin-bottom: 0;
    }
  }
  .fade:after {
    content: "";
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 70%;
    height: 1.15em;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 50%);
  }

  .publication-row, .other-publication-row {
    font-size: var(--font-size-reader);
    line-height: var(--line-height-reader);
    .scroll-anchor {
      position: relative;
      top: -48px;
    }
    .toggle-show {
      display: block;
    }
    .toggle-hide {
      display: none;
    }
    &.open {
      .toggle-show {
        display: none;
      }
      .toggle-hide {
        display: block;
      }
    }
  }

  .open .fade {
    max-height: inherit;
    &:after {
      display: none;
    }
  }
</style>
